import styled from "styled-components";

const IngredientPanelStyled = styled.div`

`;

export default IngredientPanelStyled;